import React from "react";
import { UiInfoCard } from "../../components/cards/UiInfoCard";
import { UiPointsItem, UiWishListItem } from "../../components/cards/UiInfoCardContent";

export const RecentPoints = (props) => {
    return (
        <>
            <UiInfoCard
                title="3,824"
                subtitle="Points Balance"
                contentTitle="Recent Points"
                linkTitle="View All Transactions"
                LinkTo=""
                footer={true}
            >

                <UiPointsItem
                    date="22 Nov 2022"
                    id="NR7107463"
                    points="+55 Points"
                />

                <UiPointsItem
                    date="22 Nov 2022"
                    id="NR7107463"
                    points="+55 Points"
                />

                <UiPointsItem
                    date="22 Nov 2022"
                    id="NR7107463"
                    points="+55 Points"
                />

            </UiInfoCard>
        </>
    )

}